module.exports = __webpack_public_path__ + "img/grimacing.817f16b5.png";